import { ACTION_VIEW_PAGE } from 'utils/analytics/eventTypeConstantsAmplitude';
import { IconArrowRight } from '@tock/icons/dist';
import { Link, Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import {
  tockTenCardContainer,
  tockTenCardContentContainer,
  tockTenCardImage,
  tockTenCardImageContainer,
  tockTenCardTextContainer,
} from 'components/business/landing-page/tockTenCardCssDefs';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';

interface TockTenCardProps {
  name: string;
  description?: string | null;
  imageUrl?: string | null;
  marketingUrl: string;
  business: consumer.BusinessConfig;
}

const TockTenCard: React.FC<TockTenCardProps> = ({
  name,
  description,
  imageUrl,
  marketingUrl,
  business,
}) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();

  return (
    <div css={tockTenCardContainer}>
      <div css={tockTenCardContentContainer}>
        <div css={tockTenCardImageContainer}>
          <img css={tockTenCardImage} src={imageUrl ?? undefined} alt={`${name} Poster`} />
        </div>
        <div css={tockTenCardTextContainer}>
          <Typography variant="body01Strong" mb={0.5}>
            {name}
          </Typography>
          <Typography variant="body02">{description}</Typography>
          <Link
            href={marketingUrl}
            target="__blank"
            onClick={() =>
              amplitudeSendEvent(ACTION_VIEW_PAGE, {
                businessId: business.id,
                businessName: business.name,
                title: `Tock Ten Collection - ${name}`,
              })
            }
          >
            View the collection <IconArrowRight fontSize="inherit" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TockTenCard;
